import React, { useState } from 'react';
import { Tabs } from 'antd';
import Job from './job';
import LocationComponent from './location';

const JobWithLocation: React.FC = () => {
  const [activeTab, setActiveTab] = useState<string>('job');

  const items = [
    {
      key: 'job',
      label: '📋 Job',
      children: <Job />,
    },
    {
      key: 'location',
      label: '📍 Location',
      children: <LocationComponent />,
    },
  ];

  return (
    <Tabs
      activeKey={activeTab}
      onChange={setActiveTab}
      items={items}
      style={{ background: '#fff', padding: '16px', borderRadius: '4px' }}
    />
  );
};

export default JobWithLocation;
